import React, { useRef, useState } from 'react';
import {
  Container,
  HeaderWrapper,
  MainWrapper,
} from 'lib/components/styles/layout';
import { Heading } from 'lib/components/styles/typography';
import { Tab, Tabs } from 'lib/components/tabs';
import { useTheme } from 'styled-components/macro';
import { Content } from '../../aiAssistants/components/styles';
import { Button } from 'react-covideo-common';
import { MdAdd } from 'react-icons/md';
import { Highlights } from '../highlights/Highlights';
import { Pronunciations } from '../pronunciations/Pronunciations';

interface HighlightsRef {
  openAddModal: () => void;
}
interface PronunciationsRef {
  openAddModal: () => void;
}

export const Main = () => {
  const theme = useTheme();
  const [activeTab, setActiveTab] = useState(0);
  const highlightsRef = useRef<HighlightsRef>(null);
  const pronunciationsRef = useRef<PronunciationsRef>(null);

  const tabs: Tab[] = [
    {
      title: 'Dealership Highlights',
      inActiveTextColor: theme.colors.neutral[60],
      component: activeTab == 0 ? <Highlights ref={highlightsRef} /> : null,
    },
    {
      title: 'Pronunciations',
      inActiveTextColor: theme.colors.neutral[60],
      component:
        activeTab == 1 ? <Pronunciations ref={pronunciationsRef} /> : null,
    },
  ];

  return (
    <Container>
      <MainWrapper resetPadding={false}>
        <HeaderWrapper m='0 0 26px 16px'>
          <Heading>Personalization</Heading>
          {activeTab === 0 && (
            <Button
              text='Add Highlight'
              icon={<MdAdd color={theme.colors.white[100]} />}
              onClick={() => highlightsRef.current?.openAddModal()}
            />
          )}
          {activeTab === 1 && (
            <Button
              text='Add Pronunciation'
              icon={<MdAdd color={theme.colors.white[100]} />}
              onClick={() => pronunciationsRef.current?.openAddModal()}
            />
          )}
        </HeaderWrapper>
        <Content>
          <Tabs
            tabs={tabs}
            defaultActiveTab={activeTab}
            onChange={setActiveTab}
            navbarPadding='16px 0px 0px 0px'
          />
        </Content>
      </MainWrapper>
    </Container>
  );
};
